import { createPinia } from 'pinia';
import { socketIoInstance } from '@/vuex/plugins/websocket.util';
import { analyticsPlugin } from './plugins/analytics.plugin';
import { sessionPlugin } from './plugins/session.plugin';
import { createSocketIoPlugin } from './plugins/socket-io.plugin';

export const pinia = createPinia();

pinia.use(analyticsPlugin);
pinia.use(sessionPlugin);
pinia.use(createSocketIoPlugin(socketIoInstance));
